module.exports = __webpack_public_path__ + "img/free.4be55978.jpg";